import { useCallback, useRef, useState } from "react";

export const useSwipe = ({ onSwipe }) => {
	const [startPosition, setStartPosition] = useState({
		x: 0,
		y: 0,
	});

	const isSwipingRef = useRef(false);

	const handleStart = useCallback((event) => {
		event.preventDefault();
		event.stopPropagation();

		const x = event.touches ? event.touches[0].clientX : event.clientX;
		const y = event.touches ? event.touches[0].clientY : event.clientY;

		setStartPosition({ x, y });

		isSwipingRef.current = true;
	}, []);

	const handleEnd = useCallback(
		(event) => {
			event.preventDefault();
			event.stopPropagation();

			const x = event.changedTouches
				? event.changedTouches[0].clientX
				: event.clientX;
			const y = event.changedTouches
				? event.changedTouches[0].clientY
				: event.clientY;

			const deltaX = x - startPosition.x;
			const deltaY = y - startPosition.y;

			onSwipe({ deltaX, deltaY });

			isSwipingRef.current = false;
		},
		[startPosition, onSwipe]
	);

	const handleMove = useCallback((event) => {
		if (!isSwipingRef.current) {
			return;
		}

		// Avoid scrolling
		event.preventDefault();
	}, []);

	const handleWrapperClick = useCallback((event) => {
		event.preventDefault();
		event.stopPropagation();
	}, []);

	return {
		isSwipingRef,
		handleEnd,
		handleMove,
		handleStart,
		handleWrapperClick,
	};
};
